import React, { Component } from 'react';
import { CloudinaryRawFieldProps, CloudinaryRawFieldState } from './CloudinaryRawFieldModel';
import { Modal } from 'antd';
import { CloudinaryPublicIdMediaStepper, CloudinaryPublicIdPreview, ModalTitle } from '..';

import styles from './CloudinaryRawField.module.scss';
import { CLOUDINARY_RAW } from '../../services/cloudinaryUtils';

class CloudinaryRawField extends Component<CloudinaryRawFieldProps, CloudinaryRawFieldState> {

    constructor(props: CloudinaryRawFieldProps) {
        super(props);

        this.state = {
            visible: false,
            publicId: this.props.fieldData.value ? this.props.fieldData.value : '',
        };

        this.onConfirmSelection = this.onConfirmSelection.bind(this);
        this.toggleImageEditor = this.toggleImageEditor.bind(this);
        this.onReset = this.onReset.bind(this);

    }

    onConfirmSelection(publicId: string) {
        this.setState({ publicId });
        this.props.onChange(publicId);
        this.toggleImageEditor();
    }

    toggleImageEditor() {
        const { visible } = this.state;
        if (!visible) {
            this.setState({
                publicId: this.props.fieldData.value ? this.props.fieldData.value : '',
                visible: !visible
            });
        } else {
            this.setState({
                visible: !visible
            });
        }
    }

    onReset() {
        this.setState({ publicId: '' });
        this.props.onChange(undefined);
    }

    render() {
        const { publicId } = this.state;
        const { id, disableActions } = this.props;
        return (
            <div id={id}>
                <CloudinaryPublicIdPreview
                    type={CLOUDINARY_RAW}
                    disableActions={disableActions}
                    value={publicId}
                    toggleImageEditor={this.toggleImageEditor}
                    onReset={this.onReset}
                />
                <Modal
                    title={
                        <ModalTitle onCancel={this.toggleImageEditor}>
                            {this.props.fieldData.id}
                        </ModalTitle>}
                    closable={false}
                    visible={this.state.visible}
                    wrapClassName={styles.CloudinaryRawModalPreview}
                    destroyOnClose={true}
                    footer={false}
                >
                    <CloudinaryPublicIdMediaStepper
                        field={this.props.fieldData}
                        type={CLOUDINARY_RAW}
                        onConfirmSelection={this.onConfirmSelection}
                    />
                </Modal>
            </div>
        );
    }
}

export default CloudinaryRawField;
